"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var appBuilder;
        (function (appBuilder) {
            var launchOptions;
            (function (launchOptions) {
                class InitArgs {
                    constructor() {
                        this.appCode = appn.emptyString;
                        this.deepLinkPrefix = appn.emptyString;
                        this.buildIcon = appn.emptyString;
                        this.firstRun = false;
                        this.screenTypes = appn.emptyString;
                        this.exportLaunchOptions = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                }
                launchOptions.init = init;
                function addEvents() {
                    $('.btnAddLaunchRule').on('click', function (event) {
                        event.preventDefault();
                        if ($('tbody .dataTables_noData').length)
                            $('tbody').html(appn.emptyString);
                        $('.btn-save').removeClass('d-none');
                        const idx = $('#dtItemsOptions tbody').children().length;
                        $('#dtItemsOptions tbody').append(rowBuilder(idx));
                        addControls();
                        appn.select.init({
                            selector: `#AppConfig_LaunchOptions_LaunchRules_${idx}__InteractTarget`
                        });
                    });
                    $('#exportLaunchOptions').click(function (event) {
                        event.preventDefault();
                        appn.ajax.get({
                            url: _initArgs.exportLaunchOptions,
                            data: {},
                            done: function () {
                                parent.appn.notifications.updateNotificationTotal();
                                appn.ui.showExportConfirmation('Launch Options');
                            }
                        });
                    });
                    $('#importLaunchOptions').click(function (e) {
                        e.preventDefault();
                        $('#importDialog').modal('show');
                    });
                    addControls();
                }
                function addControls() {
                    $('.delete_button').off().on('click', function () {
                        $(this).parents('tr').remove();
                        renameRows();
                    });
                    $('.buildIcon').off().on('click', function () {
                        const icon = $(this);
                        const incomingValueParams = String($(this).closest('tr').find('.dataCol.incomingValue input').val());
                        setFormulaParamFields(incomingValueParams);
                        const formulaInput = $(this).closest('.dataCol').find('textarea');
                        appn.ui.formulabuilder.currentFormula = formulaInput.val();
                        appn.ui.formulabuilder.currentMode = icon.data('type');
                        appn.ui.formulabuilder.formulaUpdated = function (formula) {
                            formulaInput.val(formula);
                        };
                        appn.ui.formulabuilder.showDialog();
                    });
                }
                function rowBuilder(idx) {
                    return '<tr><td class="dataCol incomingValue"><div class="input-group input-group-sm"><div class="input-group-prepend">' +
                        `<span class="input-group-text">${_initArgs.deepLinkPrefix}</span>` +
                        '</div>' +
                        `<input class="form-control form-control-sm tableData" id="AppConfig_LaunchOptions_LaunchRules_${idx}__IncomingValue" name="AppConfig.LaunchOptions.LaunchRules[${idx}].IncomingValue" type="text"></input>` +
                        '</div></td><td class="dataCol">' +
                        `<select id="AppConfig_LaunchOptions_LaunchRules_${idx}__InteractTarget" name="AppConfig.LaunchOptions.LaunchRules[${idx}].InteractTarget"  class="form-control form-control-sm tableData">` +
                        `<option value="">${appn.strings.chooseScreen}</option>` +
                        `${_initArgs.screenTypes}` +
                        '</select></td><td class="dataCol">' +
                        `<input class="form-control form-control-sm tableData" id="AppConfig_LaunchOptions_LaunchRules_${idx}__InteractValue" name="AppConfig.LaunchOptions.LaunchRules[${idx}].InteractValue" type="text"></input>` +
                        '</td><td class="dataCol"><div class="input-group input-group-sm">' +
                        `<textarea rows="1" class="form-control form-control-sm tableData" id="AppConfig_LaunchOptions_LaunchRules_${idx}__Formula" name="AppConfig.LaunchOptions.LaunchRules[${idx}].Formula" type="text"></textarea>` +
                        '<span class="input-group-append">' +
                        appn.elementBuilder.buildIconButton('parameters') +
                        `</span></div></td><td>${appn.elementBuilder.buildBtnRemoveRow('delete_button')}</td></tr>`;
                }
                function setFormulaParamFields(url) {
                    if (!url || url === null || url.length <= 0)
                        return;
                    let params = new Array();
                    if (url.containsIgnoreCase('?'))
                        params = url.split('?')[1].split('&');
                    $('#formulaFields').children('option').each(function (index, element) {
                        if (String($(element).val()).length > 0)
                            $(element).remove();
                    });
                    if (params && params !== null && params.length > 0)
                        for (let i = 0; i < params.length; i++) {
                            const param = params[i].split('=');
                            $('#formulaFields').append(`<option value="${param[0]}">${param[0]}</option>`);
                        }
                }
                function renameRows() {
                    let idx = 0;
                    $('#dtItemsOptions tbody tr').each(function () {
                        $(this).find('td.dataCol').each(function () {
                            const input = $(this).find('.tableData');
                            input.attr('name', String(input.attr('name')).replace(/\d+/, String(idx)));
                            input.attr('id', String(input.attr('id')).replace(/\d+/, String(idx)));
                        });
                        idx++;
                    });
                }
            })(launchOptions = appBuilder.launchOptions || (appBuilder.launchOptions = {}));
        })(appBuilder = views.appBuilder || (views.appBuilder = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
